import styled, { css } from "styled-components";
import { focusOutline } from "styles/focus";
import { ButtonTone, toneColor } from "../Button/Button.style";

export interface IconButtonStyleProps {
  $compact?: boolean;
  $tone?: ButtonTone;
}

// Every icon-only control: a quiet glyph in a square hit area that tints on
// hover. 36px by default, 28px where it sits inside an input or a table row.
// The glyph takes the button's colour, so an Icon (a CSS mask) and an inline
// svg both follow the tone and the hover.
export const iconButtonStyles = css<IconButtonStyleProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: ${({ $compact }) => ($compact ? "28px" : "36px")};
  height: ${({ $compact }) => ($compact ? "28px" : "36px")};
  border-radius: 2px;
  color: ${({ $tone = "muted", theme }) => toneColor($tone, theme)};
  transition:
    background-color 0.2s,
    color 0.2s;

  .icon {
    width: ${({ $compact }) => ($compact ? "16px" : "20px")};
    height: ${({ $compact }) => ($compact ? "16px" : "20px")};
    margin: 0;
    background-color: currentColor;
  }

  svg {
    width: ${({ $compact }) => ($compact ? "16px" : "20px")};
    height: ${({ $compact }) => ($compact ? "16px" : "20px")};
  }

  svg,
  svg path {
    fill: currentColor;
  }

  &:hover {
    background-color: ${({ theme }) => theme.subtleHover};
    color: ${({ $tone = "muted", theme }) =>
      $tone === "muted" ? theme.textMain : toneColor($tone, theme)};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
    background-color: transparent;
  }

  ${focusOutline}
`;

export const Wrapper = styled.button<IconButtonStyleProps>`
  ${iconButtonStyles}
`;
